(() => {
  'use strict';
  const configElement = document.getElementById('gap-search-intent-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const rules = config.rules || [
    { aliases: ['bag', 'bags'], query: config.bagsQuery },
    { aliases: ['tote', 'totes', 'totebag', 'totebags'], query: config.totesQuery }
  ];
  const normalize = (term) => {
    const compact = String(term || '').trim().toLowerCase().replace(/[\s-]+/g, '');
    const rule = rules.find((candidate) => candidate.aliases.includes(compact));
    return rule?.query || null;
  };
  const setQuery = (url, query) => {
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[unavailable_products]', 'last');
    return url;
  };
  const current = new URL(window.location.href);
  const searchPath = new URL(config.searchUrl, current.origin).pathname;
  const directQuery = normalize(current.searchParams.get('q'));
  if (current.pathname === searchPath && directQuery && !current.searchParams.has('section_id')) {
    current.searchParams.delete('page');
    window.location.replace(setQuery(current, directQuery).href);
    return;
  }
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('.header-search__form, .header-search-bar')) return;
    const data = new FormData(form);
    const query = normalize(data.get('q'));
    if (!query) return;
    event.preventDefault();
    const destination = new URL(form.action, current.origin);
    for (const [name, value] of data) destination.searchParams.set(name, String(value));
    const previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (previewId) destination.searchParams.set('preview_theme_id', previewId);
    window.location.assign(setQuery(destination, query).href);
  }, true);
  const patchPredictiveSearch = () => {
    const search = window.Alpine?.store('search');
    if (!search || search._gapBagSearchPatched) return;
    const buildSuggestUrl = search.buildSuggestUrl;
    search.buildSuggestUrl = function () {
      const query = normalize(this.term);
      if (!query) return buildSuggestUrl.call(this);
      const destination = setQuery(new URL(config.searchUrl, window.location.origin), query);
      destination.searchParams.set('section_id', 'header-search');
      return destination.pathname + destination.search;
    };
    search._gapBagSearchPatched = true;
  };
  document.addEventListener('alpine:initialized', patchPredictiveSearch, { once: true });
  patchPredictiveSearch();
})();
